"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ostra-vetere": {
    "78206fbd": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "acqualagna": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b822083d": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "boscareto": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80816a82": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "dometto": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b931dece": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "guinzano": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02efbf4c": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "pescara": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b16c2dd": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "pezzolo": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c876b88e": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito": [{
      "hkey": "75ee764a",
      "slug": "ostra-vetere",
      "name": "Ostra Vetere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;